import { logException } from "@wss/error-tracking";

type UploadFileResponse = {
  success: boolean;
  originalFileName: string;
  serverFileName: string;
};

type RemoveFileResponse = {
  exceptionOccurred: boolean;
};

export const removeFileFromReview = async (
  itemNumber: string,
  fileName: string,
  serverFileName: string,
  fileType: string
) => {
  const body = new FormData();
  body.append("itemNumber", itemNumber);
  body.append("fileName", fileName);
  body.append("serverFileName", serverFileName);
  body.append("fileType", fileType);

  try {
    const response = await fetch("/myaccount/reviews/removeuserreviewfile/", {
      method: "POST",
      body,
      credentials: "include",
    });

    if (response.ok) {
      return await response.json<RemoveFileResponse>();
    }
    return new Error("File removal failed");
  } catch (err) {
    logException(err);
    return new Error("File removal failed.");
  }
};

export const uploadPhotos = async (itemNumber: string, files: File[]) => {
  const body = new FormData();
  body.append("itemNumber", itemNumber);
  files.forEach((f) => body.append("photoFile", f, f.name));

  try {
    const response = await fetch("/myaccount/reviews/submituserphoto/", {
      method: "POST",
      body,
      credentials: "include",
    });

    if (response.ok) {
      return await response.json<UploadFileResponse[]>();
    }
    if (response.status === 400) {
      return new Error("Missing necessary field(s).");
    }
    return new Error("Photo upload failed");
  } catch (err) {
    logException(err);
    return new Error("Photo upload failed.");
  }
};

export const uploadVideos = async (itemNumber: string, files: File[]) => {
  const body = new FormData();
  body.append("itemNumber", itemNumber);
  files.forEach((f, i) => {
    body.append(`videoFileSize${i + 1}`, f.size.toString());
    body.append(`videoFile${i + 1}`, f, f.name);
  });

  try {
    const response = await fetch("/myaccount/reviews/submituservideo/", {
      method: "POST",
      body,
      credentials: "include",
    });

    if (response.ok) {
      return await response.json<UploadFileResponse[]>();
    }
    if (response.status === 400) {
      return new Error("Missing necessary field(s).");
    }
    return new Error("Video upload failed.");
  } catch (err) {
    logException(err);
    return new Error("Video upload failed.");
  }
};

export const submitReview = async (
  form: HTMLFormElement,
  recaptchaToken: string
) => {
  const body = new FormData(form);
  body.append("isAjax", "true");
  body.append("renderPage", "false");
  body.append("recaptchaToken", recaptchaToken);
  body.append("customerUrl", window.location.pathname);

  // Remove empty file input
  body.delete("imageUpload");

  try {
    const response = await fetch("/myaccount/reviews/saveuserreview/", {
      method: "POST",
      body,
      credentials: "include",
    });
    return response;
  } catch (err) {
    logException(err);
    return new Error("Form submission failed.");
  }
};
